export default __webpack_public_path__ + "static/media/deflaton.c952cc00.png";